// src/utils/getUserId.js

/**
 * Decodes a JWT token and extracts the user ID.
 * No external library needed — just base64 decode the payload.
 */
function decodeJwtUserId(token) {
    try {
        if (!token || typeof token !== "string") return "";
        const parts = token.split(".");
        if (parts.length !== 3) return "";

        // Base64url decode the payload (middle part)
        const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        const json = decodeURIComponent(
            atob(base64)
                .split("")
                .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                .join(""),
        );

        const payload = JSON.parse(json);

        // Try common id field names in JWT payloads
        return (
            payload?._id ||
            payload?.id ||
            payload?.userId ||
            payload?.user_id ||
            payload?.sub ||
            ""
        );
    } catch {
        return "";
    }
}

/**
 * Gets the current user's ID.
 * Tries localStorage direct keys first, then decodes the JWT as fallback.
 */
export function getStoredUserId() {
    // 1. Try direct localStorage keys
    const direct =
        localStorage.getItem("userId") ||
        localStorage.getItem("user_id") ||
        localStorage.getItem("uid") ||
        localStorage.getItem("id");

    if (direct) return direct;

    // 2. Try parsing stored user objects
    const objectKeys = ["user", "userData", "userInfo", "currentUser", "profile"];
    for (const key of objectKeys) {
        try {
            const raw = localStorage.getItem(key);
            if (!raw) continue;
            const parsed = JSON.parse(raw);
            const id =
                parsed?._id ||
                parsed?.id ||
                parsed?.userId ||
                parsed?.user_id ||
                parsed?.uid;
            if (id) return String(id);
        } catch {
            // not JSON, skip
        }
    }

    // 3. ✅ Decode JWT from authToken as final fallback
    const token =
        localStorage.getItem("authToken") ||
        localStorage.getItem("token") ||
        localStorage.getItem("accessToken");

    const fromJwt = decodeJwtUserId(token);
    if (fromJwt) return String(fromJwt);

    return "";
}